<div class="about-content">
  <div class="about-image">
    <img
      [src]="data.imgsrc"
      alt="template image"
    />
  </div>
  <div class="about-desc">
    <h5 style="color: var(--secondary-color)">{{data.title}}</h5>
    <p>
      {{data.content}}
    </p>
  </div>
</div>
